import { TextField, Typography, Dialog, Button, Toast } from "@/components/kit";
import { useDeleteRole } from "@/hooks/query/acl/useDeleteRole";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

interface IDeleteRoleModal {
  handleClose: () => void;
  isOpen: boolean;
  roleName: string;
}

function DeleteRoleModal({ isOpen, handleClose, roleName }: IDeleteRoleModal) {
  const [deleteText, setDeleteText] = useState<string>();
  const { mutate: deleteRole, isPending } = useDeleteRole();
  const queryClient = useQueryClient();
  const handleCloseModal = () => {
    setDeleteText("");
    handleClose();
  };
  const handleDelete = () => {
    deleteRole(roleName, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ["TrioRoles"] });
        Toast({
          status: "success",
          description: "The role has been deleted.",
          title: "Success",
        });
        handleCloseModal();
      },
    });
  };
  return (
    <Dialog title={`Delete ${roleName}`} handler={handleClose} open={isOpen}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleDelete();
        }}
        className="mt-2 mb-2"
      >
        <Typography
          variant="Body2-Regular"
          color="text-gray-600"
          className="block mb-5"
        >
          Once deleted, this role will be unassigned, and access will be revoked
          for users.
        </Typography>
        <Typography
          variant="Body2-Regular"
          color="text-gray-600"
          className="block mb-3"
        >
          To confirm, please type
          <Typography variant="Body2-Bold" color="text-gray-800">
            {" "}
            &apos;Delete&apos;{" "}
          </Typography>{" "}
          to confirm.
        </Typography>
        <TextField
          value={deleteText}
          onChange={(e) => setDeleteText(e.target.value)}
          placeholder="Type Delete here"
          className="mb-8"
        />
        <div className="flex justify-end gap-2">
          <Button
            variant="outlined"
            color="red"
            disabled={deleteText !== "Delete"}
            type="submit"
            isLoading={isPending}
          >
            Delete
          </Button>
          <Button onClick={handleCloseModal} disabled={false}>
            Cancel
          </Button>
        </div>
      </form>
    </Dialog>
  );
}

export default DeleteRoleModal;
